module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/extension-worker/extension-worker.ce08fc5af725e4c25466.js");
};